<template>
  <simple-page class="h-100 bg-primary">
    <div class="col-md-6 col-lg-4">
      <!--
      ==========================================================================
      Page header
      ==========================================================================
      -->
      <h2 class="text-white text-center">
        <i class="fa fa-fw fa-info"></i>
        {{ $env.app.name }}
      </h2>

      <!--
      ==========================================================================
      Page body
      ==========================================================================
      -->
      <b-card class="rounded-lg text-center" style="box-shadow: lightgray 4px 4px 4px;">
        <strong v-if="flash" :class="'text-' + flashVariant">
          {{ flash }}
        </strong>

        <!--
        <b-button
          v-if="$env.app.offlineSupport"
          variant="link"
          block
          :to="$route.query.redirect || defaultRoute">
          {{ $t('login.actions.proceed') }}
        </b-button>
        -->
      </b-card>
      <!--
      ==========================================================================
      Page footer
      ==========================================================================
      -->
      <div class="text-right mt-2">
        <!--
        <router-link
          class="font-decoration-none text-white font-weight-bold"
          :to="{ name: 'ResetPassword' }">
          {{ $t('login.actions.resetPassword') }}
        </router-link>
        -->
      </div>
    </div>
  </simple-page>
</template>
<script>
import FlashMessageSupportMixin from 'vue-template/common/mixins/FlashMessageSupportMixin';

export default {
  mixins: [FlashMessageSupportMixin],
  
  props: {
    defaultRoute: {
      type: [String, Object],
      default: '/'
    },
  },

  methods: {
  }
};
</script>
